import {createAction, createReducer} from 'redux-act';
import {createSelector} from 'reselect';

import {ApplicationStoreType} from 'reducers';
import {isCustomerLogged} from 'selectors/customer/customer';
import {WishlistType} from './wishlistType';
import {WISHLIST_ITEMS_COUNT_LIMIT} from 'constants/customer';

export const initialState: WishlistType = {
    ids: [],
    isPopup: false,
    isSet: false,
};

/**
 * Sets wishlist items ids
 */
export const setWishlistIds = createAction<number[]>('SET_WISHLIST_ITEMS');
/**
 * Set wishlist popup visibility
 */
export const setPopupVisibility = createAction<boolean>('SET_WISHLIST_POPUP_VISIBILITY');

/**
 * Wishlist reducer
 */
export const wishlist = createReducer<WishlistType>({}, initialState)
    .on(
        `${setWishlistIds}`,
        (state: WishlistType, payload: number[]): WishlistType => ({
            ...state,
            ids: payload,
            isSet: true,
        }),
    )
    .on(
        `${setPopupVisibility}`,
        (state: WishlistType, payload: boolean): WishlistType => ({
            ...state,
            isPopup: payload,
        }),
    );

/**
 * Defines if wishlist was set at least once
 * @param {ApplicationStoreType} store - current store
 * @returns {boolean} true if wishlist was set at least once
 */
export const isWishlistReady = (store: ApplicationStoreType) => store.wishlist.isSet;
/**
 * Get wishlist items ids
 * @param {ApplicationStoreType} store - current store
 * @returns {number[]} wishlist items ids
 */
export const getWishlistIds = (store: ApplicationStoreType) => store.wishlist.ids;
/**
 * Get wishlist items count
 * @param {ApplicationStoreType} store - current store
 * @returns {number} wishlist items count
 */
export const getWishlistCount = (store: ApplicationStoreType) => store.wishlist.ids.length;
/**
 * Defines if user can't add more wishlist items
 * @param {ApplicationStoreType} store - Application store
 * @returns {boolean} true if user can't add more wishlist items
 */
export const isOverLimit = createSelector(
    getWishlistCount,
    isCustomerLogged,
    (count, isLogged): boolean => count >= WISHLIST_ITEMS_COUNT_LIMIT && !isLogged,
);
/**
 * Returns true if wishlist popup should be shown
 * @param {ApplicationStoreType} store - current store
 * @returns {boolean} true if wishlist popup should be shown
 */
export const isWishlistPopupToShow = (store: ApplicationStoreType) => store.wishlist.isPopup;
